import createDmarcIpsStore from 'sen/redux/features/dataTables/dmarcIps/createDmarcIpsStore'

export const dmarcPassedIps = createDmarcIpsStore('PASSED')

export { INITIAL_STATE } from 'sen/redux/features/dataTables/dmarcIps/createDmarcIpsStore'
export const { update, reset } = dmarcPassedIps.actions
export default dmarcPassedIps.reducer
